import { IButtonStyles } from '@fluentui/react';
import { BoxShadow, IH2OTheme, Sizes } from '@h2oai/ui-kit';

const OCCUPIED_HEIGHT = 632;

export const customGroupConnectionDetailsStyles = (theme: IH2OTheme) => ({
  display: 'grid',
  gridTemplateColumns: '1fr 1fr 1fr',
  gap: '20px',
  padding: Sizes.padding,
  marginBottom: '1.5rem',
  backgroundColor: theme.palette?.white,
  borderRadius: Sizes.borderRadius,
  boxShadow: BoxShadow,
  color: theme.palette?.gray300,
});

export const sectionHeaderStyles = (theme: IH2OTheme) => ({
  paddingBottom: '12px',
  borderBottom: `2px solid ${theme.palette?.gray200}`,
});

export const createGroupSectionStyles = (_theme?: IH2OTheme) => ({
  marginBottom: '1rem',
  padding: '24px',
  paddingBottom: '16px',
  backgroundColor: '#fafafa',
  borderRadius: '8px',
  border: '1px solid #e1e1e1',
});

export const createGroupFormStyles = () => ({
  display: 'flex',
  alignItems: 'flex-start',
  gap: '16px',
  marginTop: '16px',
});

export const infoLabelStyles = (theme: IH2OTheme) => ({
  fontWeight: 'bold',
  color: theme.palette?.gray600,
});

export const infoValueStyles = (theme: IH2OTheme) => ({
  fontFamily: "'Consolas', 'Monaco', 'Courier New', monospace",
  fontSize: '12px',
  backgroundColor: theme.palette?.gray200,
  color: theme.palette?.gray700,
  padding: '2px 6px',
  borderRadius: '4px',
  border: `1px solid ${theme.palette?.gray200}`,
  fontWeight: '500',
  width: 'fit-content',
});

export const messageBarContainerStyles = () => ({
  position: 'fixed' as const,
  top: Sizes.padding,
  right: Sizes.padding,
  zIndex: 9999999,
  width: 'auto',
});

export const overlayContainerStyles = () => ({
  position: 'absolute' as const,
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: 'rgba(255, 255, 255, 0.8)',
  display: 'flex' as const,
  alignItems: 'center' as const,
  justifyContent: 'center' as const,
  zIndex: 2,
  flexDirection: 'column' as const,
  gap: '16px',
});

export const groupItemStyles = (theme: IH2OTheme) => ({
  display: 'flex',
  alignItems: 'center',
  padding: '12px 16px',
  margin: '4px 0',
  backgroundColor: theme.palette?.gray200,
  borderRadius: '6px',
  transition: 'all 0.2s ease',
  cursor: 'pointer',

  ':hover': {
    backgroundColor: theme.palette?.gray300,
  },
});

export const shimmerItemStyles = (theme: IH2OTheme) => ({
  display: 'flex',
  alignItems: 'center',
  padding: '12px 16px',
  margin: '4px 0',
  backgroundColor: theme.palette?.gray200,
  borderRadius: '6px',
});

export const groupListRoot = () => ({
  padding: '24px',
  backgroundColor: '#fafafa',
  borderRadius: '8px',
  border: '1px solid #e1e1e1',
  maxHeight: `calc(100vh - ${OCCUPIED_HEIGHT}px)`,
  overflowY: 'hidden' as const,
});

export const groupListHeaderStyles = () => ({
  marginBottom: '1rem',
  paddingBottom: '12px',
  borderBottom: '2px solid #f0f0f0',
  display: 'flex',
  justifyContent: 'space-between',
});

export const itemsContainer = () => ({
  maxHeight: `calc(100vh - ${OCCUPIED_HEIGHT + 128}px)`,
  overflowY: 'auto' as const,
});

export const createButtonStyles = (theme: IH2OTheme): IButtonStyles => ({
  root: {
    color: theme.semanticColors?.buttonPrimaryText,
    backgroundColor: theme.semanticColors?.buttonPrimaryBackground,
    borderColor: theme.semanticColors?.buttonPrimaryBackground,
    marginTop: '27px',
  },
  rootFocused: {
    backgroundColor: theme.semanticColors?.buttonPrimaryActiveBackground,
    borderColor: theme.semanticColors?.buttonPrimaryActiveBorder,
    color: theme.semanticColors?.buttonPrimaryText,
  },
  rootPressed: {
    backgroundColor: theme.semanticColors?.buttonPrimaryActiveBackground,
    borderColor: theme.semanticColors?.buttonPrimaryActiveBorder,
    color: theme.semanticColors?.buttonPrimaryText,
  },
  rootHovered: {
    backgroundColor: theme.semanticColors?.buttonPrimaryHoverBackground,
    borderColor: theme.semanticColors?.buttonPrimaryHoverBackground,
    color: theme.semanticColors?.buttonPrimaryText,
  },
  icon: {
    color: theme.semanticColors?.buttonPrimaryText,
  },
  menuIcon: {
    color: theme.semanticColors?.buttonPrimaryText,
  },
  rootDisabled: {
    color: theme.semanticColors?.buttonPrimaryDisabledText,
    backgroundColor: theme.semanticColors?.buttonPrimaryDisabledBackground,
    borderColor: theme.semanticColors?.buttonPrimaryDisabledBorder,
    pointerEvents: 'none',
  },
});
